import clsx from 'clsx'
import React, { FC } from 'react'

import { CatalogFilterValue } from '@/entities/catalog-old/types/type'

import { CheckboxGroup } from '@/shared/ui/checkbox'

import cls from './checkbox-list.module.scss'

interface CheckboxListProps {
	items: CatalogFilterValue[]
	name: string
	open?: boolean
	isDisabled?: boolean
}

export const CheckboxList: FC<CheckboxListProps> = ({ items, name, open, isDisabled }) => {
	const checkedValues = items.filter(({ CHECKED }) => Boolean(CHECKED)).length

	const normalizedItems = [...items]
		.map((item, index) => ({
			...item,
			index
		}))
		.sort((a, b) => {
			const aChecked = Number(Boolean(a.CHECKED))
			const bChecked = Number(Boolean(b.CHECKED))

			if (aChecked !== bChecked) {
				return bChecked - aChecked
			}

			return a.index - b.index
		})

	const visibleItems = open
		? normalizedItems
		: [
				...normalizedItems.filter(({ CHECKED }) => Boolean(CHECKED)),
				...normalizedItems.filter(({ CHECKED }) => !Boolean(CHECKED)).slice(0, Math.max(0, 5 - checkedValues))
		  ]

	const adaptedValue = visibleItems.map(({ NAME, VALUE, CHECKED, ELEMENT_COUNT }) => ({
		label: NAME ?? VALUE.toString(),
		value: VALUE,
		checked: CHECKED,
		disabled: !ELEMENT_COUNT
	}))

	return (
		<div className={clsx(cls.root)}>
			<CheckboxGroup name={name} items={adaptedValue} isDisabled={isDisabled} />
		</div>
	)
}
